<template>
  <el-main class="filed">
    <ContentNav
      :bannerTextIMG="require('../assets/Field/bannerText.png')"
      :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[6].banner"
    >
    </ContentNav>
    <div class="content">
      <div
        class="content-box"
        v-for="(x, i) in Professionalfield"
        :key="i"
        @click="toDetails(i)"
      >
        <div class="title">
          <img :src="Url.imgUrl + x.logo" />
          <span>{{ x.name }}</span>
        </div>
        <div class="text">
          {{ x.description.substring(0, 88) + "..." }}
        </div>
        <div
          class="more"
          style="
            color: #d0a971;
            font-size: 14px;
            position: absolute;
            bottom: 20px;
            right: 20px;
            cursor: pointer;
          "
        >
          详情>>
        </div>
      </div>
    </div>
    <!-- 右侧浮动图标组 -->
    <transition name="el-zoom-in-center">
      <div class="Icon_group" v-if="true">
        <div class="Icon_item">
          <a href="tel:400-838-0148"
            ><img
              src="../assets/home/dianhua@3x.png"
              :alt="SystemOption.seoKeyWord"
          /></a>
        </div>
        <div class="Icon_item">
          <img
            @mouseover="isShowWXrcode = true"
            @mouseout="isShowWXrcode = false"
            src="../assets/home/weixin@3x.png"
            :alt="SystemOption.seoKeyWord"
          />
          <img
            v-if="isShowWXrcode"
            style="position: absolute; width: 143px; left: -164px; top: 54px"
            src="../assets/home/wxRode1.jpg"
            alt=""
          />
        </div>
        <div class="Icon_item" @click="backtop">
          <img src="../assets/home/top@3x.png" :alt="SystemOption.seoKeyWord" />
        </div>
      </div>
    </transition>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :modal="false"
      :before-close="handleClose"
    >
      <h3 style="text-align: center">
        {{ detailsList[FielddetailIndex].name }}
      </h3>
      <p style="margin-top: 30px; line-height: 33px">
        {{ detailsList[FielddetailIndex].description }}
      </p>
    </el-dialog>
  </el-main>
</template>

<script>
import ContentNav from "../components/ContentNav";
export default {
  components: {
    ContentNav,
  },
  metaInfo() {
    return {
      title: `专业领域-${this.SystemOption.seoTitle ?? ""}`,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.SystemOption.seoKeyWord,
        },
        {
          // set meta
          name: "description",
          content: this.SystemOption.seoDescribe,
        },
      ],
    };
  },
  data() {
    return {
      Professionalfield: [], //专业领域
      SystemOption: [], //SEO配置
      dialogVisible: false,
      FielddetailIndex: 0,
      detailsList: "",
      isShowWXrcode: false, //是否悬浮显示微信二维码
    };
  },
  methods: {
    toDetails(x) {
      this.dialogVisible = true;
      this.FielddetailIndex = x;
    },
    //回到顶部
    backtop() {
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
    //滚动监听方法
    handleScroll() {
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop > 500
        ? (this.isDisFloat = true)
        : (this.isDisFloat = false);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    //初始化路径数据
    this.$store.state.Currentposition = [
      {
        path: "/",
        name: "首页",
      },
      {
        path: "/field.html",
        name: "专业领域",
      },
    ];
    //获取SEO配置
    this.axios
      .get(this.Url.apiUrl + "SystemOption/GetSystemOption")
      .then((res) => (this.SystemOption = res.data));
    //获取专业领域
    this.axios({
      type: "get",
      url: this.Url.apiUrl + "ProfessionalField/GetProfessionalField",
    }).then((res) => {
      console.log(res);
      this.detailsList = res.data;
      let data = res.data;
      // data.forEach(element => {
      // 	if(document.body.clientWidth>768){

      // 		if(element.description.length>60){
      // 			element.description = element.description.substring(0,88)+ '...';
      // 		}
      // 	}else{
      // 		if(element.description.length>55){
      // 			element.description = element.description.substring(0,55)+ '...';
      // 		}
      // 	}

      // });
      console.log(this.detailsList);
      this.Professionalfield = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 60px 0 120px 0;

  @media screen and (max-width: 768px) {
    padding: 20px 0;
    width: 100%;
  }

  .content-box {
    display: block;
    flex: 0 0 585px;
    width: 585px;
    height: 210px;
    background-color: #ffffff;
    box-shadow: 0px 1px 10px 0px rgba(118, 118, 118, 0.3);
    border: solid 1px #d2b385;
    margin: 15px 0;
    padding: 50px 40px;
    overflow: hidden;
    cursor: pointer;
    position: relative;

    @media screen and (max-width: 768px) {
      flex: 0 0 82%;
      width: 82%;
      height: 120px;
      overflow: hidden;
      padding: 16px;
      margin: 12px auto;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .title {
      color: #cea15a;
      font-weight: 600;
      display: flex;
      align-items: center;

      @media screen and (max-width: 768px) {
        font-size: 13px;
      }

      img {
        width: 42px;
        position: absolute;
        // max-height: 25px;
        margin-right: 15px;

        @media screen and (max-width: 768px) {
          width: 42px;
        }
      }
      span {
        padding-left: 46px;
      }
    }

    .text {
      margin-top: 20px;
      color: #a9a9a9;
      font-size: 14px;
      line-height: 24px;

      @media screen and (max-width: 768px) {
        font-size: 10px;
        line-height: 20px;
        margin-top: 14px;
      }
    }
  }
}
</style>
